import { useMutation, useQuery } from 'react-query'
import { message } from 'antd'
import {
  addShift,
  editShift,
  getShift,
  getShifts,
  closeShift,
  getCurrentShift,
  getShiftDevices,
  recordShiftDevice,
} from 'utils/apis/shift'

export function useShifts(params = {}, options = {}, apiOptions = {}) {
  return useQuery(
    ['shifts', params],
    async () => {
      let response
      try {
        response = getShifts(params, apiOptions)
      } catch (error) {
        throw new Error('Failed to load data from server!')
      }
      return response
    },
    {
      onError: (error) =>
        message.error((error && error.message) || 'Failed to load data from server!'),
      ...options,
    },
  )
}

export function useShift(id, options = {}, apiOptions = {}) {
  return useQuery(
    ['shifts', id],
    async () => {
      const res = await getShift(id, apiOptions)
      return res
    },
    {
      onError: (error) =>
        message.error((error && error.message) || 'Failed to load data from server!'),
      ...options,
    },
  )
}

export const useAddShift = () => {
  return useMutation(({ apiOptions, ...data }) => addShift(data, apiOptions))
}

export const useUpdateShift = () => {
  return useMutation(editShift)
}

export const useCloseShift = () => {
  return useMutation(({ apiOptions, ...data }) => closeShift(data, apiOptions))
}

/** Cek device lain yang masih aktif pada shift (sebelum tutup shift). */
export const useCheckShiftDevices = () => {
  return useMutation(({ shiftId, apiOptions }) => getShiftDevices(shiftId, apiOptions))
}

/** Catat browser ini ke shift yang dilanjutkan (multi-device). */
export const useRecordShiftDevice = () => {
  return useMutation(({ shiftId, device_id, apiOptions }) =>
    recordShiftDevice(shiftId, { device_id }, apiOptions),
  )
}

export function useCurrentShift(params, options = {}, apiOptions = {}) {
  return useQuery(
    ['shifts', 'current', params.user_id, params.outlet_id],
    async () => {
      const res = await getCurrentShift(params, apiOptions)
      return res
    },
    {
      onError: (error) =>
        message.error((error && error.message) || 'Failed to load data from server!'),
      ...options,
    },
  )
}

export const SHIFT_STATUS_KEY = ['shifts', 'current', 'status']

// Validasi shift tersimpan (redux persist) masih open di BE. Endpoint sama dengan useCurrentShift
// (shift terakhir user di outlet: open → data, close → 400), key dipisah agar callback
// validasi tidak ikut terpanggil oleh query prompt "lanjutkan shift".
export function useShiftStatus(params, options = {}, apiOptions = {}) {
  return useQuery(
    [...SHIFT_STATUS_KEY, params.user_id, params.outlet_id],
    async () => {
      const res = await getCurrentShift(params, apiOptions)
      return res
    },
    options,
  )
}
